import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.scss';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { Settings } from 'luxon';

Settings.defaultLocale = 'vi';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
